module.exports = __webpack_public_path__ + "img/mafalda_sousa.7122d0f9.jpg";